export default "__VITE_ASSET__88223613__"